import { useEffect, useState } from 'react';

// Was inlined in ComposeDialog.tsx for its one caller. Promoted here now
// that the contact-suggestions autocomplete needs it in both composers,
// across To/Cc/Bcc — six callers is past the point where copy-pasting it
// again is the safer option.
export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
